const toggleFSLOadingRed = (state = {
	showLoadingFS: false,
	loadingFSText1: 'Loading ..',
	loadingFSText2: 'Please wait for a moment...'
}, action) => {
	switch ( action.type ) {
		case 'TOGGLE_FS_LOADING':
            return Object.assign({}, state, {
                showLoadingFS: action.payload.showLoadingFS,
                loadingFSText1: action.payload.loadingFSText1,
				loadingFSText2: action.payload.loadingFSText2
            });
		default:
			return state
	}
};

export default toggleFSLOadingRed


/** WEBPACK FOOTER **
 ** ./src/reducers/toggleFSLOadingRed.js
 **/